import { F0Alert } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  roundTrip: boolean
  calculatedMileage: number
  units: string
}

const MileageAlertCallout = ({ calculatedMileage, roundTrip, units }: Props) => {
  return (
    <F0Alert
      variant="warning"
      title={i18n.t('expenses_v2.forms.fields.mileage.alert.manually_changed.title')}
      description={
        calculatedMileage
          ? i18n.t('expenses_v2.forms.fields.mileage.alert.manually_changed.description', {
              calculated_mileage: calculatedMileage * (roundTrip ? 2 : 1),
              units: units.toLowerCase()
            })
          : i18n.t(
              'expenses_v2.forms.fields.mileage.alert.manually_changed.description_no_calculated_mileage'
            )
      }
    />
  )
}

export default MileageAlertCallout
